"use client";

import { useEffect } from "react";
import { useSession } from "@/lib/auth-client";
import { usePostHog } from "posthog-js/react";
import * as Sentry from "@sentry/browser";

export function UserContextTracker() {
  const { data: session, isPending } = useSession();
  const posthog = usePostHog();

  useEffect(() => {
    if (isPending) return;

    const user = session?.user;

    if (user) {
      posthog.identify(user.id, {
        email: user.email,
        name: user.name,
      });

      Sentry.setUser({
        id: user.id,
        email: user.email,
        name: user.name,
      });
    } else {
      posthog.reset();
      Sentry.setUser(null);
    }
  }, [session, isPending, posthog]);

  return null;
}
